import { AppState } from 'Store'

const getFields = (state: AppState) => state.orders.product.fields
const getAll = (state: AppState) => state.orders.product.products
const getEntries = (state: AppState) => state.orders.product.products.entries
const getOne = (state: AppState) => state.orders.product.product
const getTotal = (state: AppState) => state.orders.product.products.total_entries
const getParams = (state: AppState) => state.orders.product.requestParams
const getProductGroups = (state: AppState) => state.orders.product.productGroups
const getProductGroupsEntries = (state: AppState) => state.orders.product.productGroups.entries
const getCurrentPage = (state: AppState) => state.orders.product.products.current_page
const getSelectedPoductIds = (state: AppState) => state.page?.entity?.product_ids

export const productsSelector = {
	getFields,
	getAll,
	getEntries,
	getOne,
	getTotal,
	getParams,
	getProductGroups,
	getProductGroupsEntries,
	getCurrentPage,
	getSelectedPoductIds,
}
